module.exports = __webpack_public_path__ + "media/images/rectangle-4bc1c0063e15c001d8e204b60b9bbf37.svg";